/*
import IconDocument from "@/app/(components)/generics/Icons/IconDocument";
import IconMagnifyingGlass from "@/app/(components)/generics/Icons/IconMagnifyingGlass";
import IconTabletWriting from "@/app/(components)/generics/Icons/IconTabletWriting";
import IconWorld from "@/app/(components)/generics/Icons/IconWorld";
*/
import IconHeadphones from "@/app/(components)/generics/Icons/IconHeadphones";
import IconMessageSequence from "@/app/(components)/generics/Icons/IconMessageSequence";
import IconUser from "@/app/(components)/generics/Icons/IconUser";
import IconUsers from "@/app/(components)/generics/Icons/IconUsers";
import { TKey } from "@/app/translations/TKey";
import { ToolPhaseType } from "@/app/types/home/HomeTools";
import { Routes } from "@/app/vars/Routes";

export const MeidlyToolsData: ToolPhaseType[] = [
  {
    phaseTitle: TKey.HOME_MEIDLY_TOOLS_TITLE,
    tools: [
      {
        id: "01",
        title: TKey.CALL_ANALYSIS,
        desc: TKey.HOME_MEIDLY_TOOLS_2_DESC,
        icon: <IconHeadphones />,
        available: true,
        href: Routes.PROTECTED.CALL_ANALYSIS,
      },
      {
        id: "02",
        title: TKey.CLIENT_AVATAR_NAV,
        desc: TKey.HOME_MEIDLY_TOOLS_1_DESC,
        icon: <IconUser />,
        available: true,
        href: Routes.PROTECTED.CLIENT_AVATAR,
      },
      {
        id: "03",
        title: TKey.PROSPECT_SEARCH_NAV,
        desc: TKey.HOME_MEIDLY_TOOLS_6_DESC,
        icon: <IconUsers />,
        available: true,
        href: Routes.PROTECTED.PROSPECT_SEARCH,
      },
      {
        id: "04",
        title: TKey.MESSAGES_CONTENT_NAV,
        desc: TKey.HOME_MEIDLY_TOOLS_8_DESC,
        icon: <IconMessageSequence />,
        available: true,
        href: Routes.PROTECTED.MESSAGES_CONTENT,
      },
      /*
      {
        id: "05",
        title: TKey.SALES_SCRIPT_NAV,
        desc: TKey.HOME_MEIDLY_TOOLS_5_DESC,
        icon: <IconDocument />,
        available: false,
        href: "#",
      },
      {
        id: "06",
        title: TKey.CONTENT_CREATION_NAV,
        desc: TKey.HOME_MEIDLY_TOOLS_7_DESC,
        icon: <IconTabletWriting />,
        available: false,
        href: "#",
      },
      {
        id: "07",
        title: TKey.MARKET_ANALYSIS_NAV,
        desc: TKey.HOME_MEIDLY_TOOLS_3_DESC,
        icon: <IconWorld />,
        available: false,
        href: "#",
      },
      {
        id: "08",
        title: TKey.COMPETITION_NAV,
        desc: TKey.HOME_MEIDLY_TOOLS_4_DESC,
        icon: <IconMagnifyingGlass />,
        available: false,
        href: "#",
      },
      */
    ],
  },
];
